import { _js } from '@ifixit/utils/localize';

export const ErrorCodes = {
   circular_prereq: _js('Circular reference in prerequisites.'),
   self_prereq: _js('Cannot add guide as a prerequisite of itself.'),
};

const LivrCodeMessages = {
   REQUIRED: _js('is required'),
   FORMAT_ERROR: _js('has the wrong format'),
   WRONG_FORMAT: _js('has the wrong format'),
   TOO_LONG: _js('is too long'),
   NOT_ALLOWED_VALUE: _js("isn't an allowed value"),
   NOT_STRING: _js('must be text'),
   NOT_INTEGER: _js('must be a whole number'),
   NOT_POSITIVE_INTEGER: _js('must be a positive whole number'),
};

/**
 * Builds a readable message from a LIVR validation `error` object such as
 * `{ title: 'REQUIRED' }`. Returns undefined when there is nothing to show.
 */
export function formatLivrErrors(error) {
   if (!error || typeof error !== 'object') {
      return;
   }

   const messages = Object.entries(error).map(([field, code]) => {
      const readable =
         typeof code === 'string' ? (LivrCodeMessages[code] ?? code) : JSON.stringify(code);
      return `${field}: ${readable}`;
   });

   return messages.length ? messages.join('\n') : undefined;
}
